import { render, staticRenderFns } from "./AddTestProvider.vue?vue&type=template&id=31ffe5f7&"
import script from "./AddTestProvider.vue?vue&type=script&lang=js&"
export * from "./AddTestProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports